const globalFeaturesSupportObj = {
    /**
     * @type {object<boolean>}
     */
    isMobile: false,
};
const getFeature = function (feature) {
    return globalFeaturesSupportObj[feature];
};
const setFeature = function (feature, value) {
    globalFeaturesSupportObj[feature] = value;
};
export { getFeature, setFeature };
//# sourceMappingURL=imageServiceFeatureSupportObject.js.map